export default __webpack_public_path__ + "static/media/facebook-icon.ea157712.svg";